let active: HTMLVideoElement | null = null;
export function claimVideo(video: HTMLVideoElement) {
  if (active && active !== video) active.pause();
  active = video;
}
export function releaseVideo(video: HTMLVideoElement) {
  if (active === video) active = null;
}